// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jr-designer{position:absolute;top:0;left:0;z-index:10000}.jr-add-section-btn{position:fixed;right:100px;bottom:100px;z-index:10001}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
